import CreativeDirectorSortableAdJobsList from "../react/CreativeDirectorSortableAdJobsList";

export default class AdJobQueues {
  show() {
    const keys = ["in_design", "design"];
    const klass = CreativeDirectorSortableAdJobsList;
    this.sortAds(keys, klass);
  }

  sortAds(keys, klass) {
    keys.forEach((ele) => {
      if ($(`.js-ads-react-data-${ele}`).length) {
        const list = new klass({
          sortScope: `#sort-filters-${ele}`,
          selector: `.js-ads-list-${ele}`,
          data: $(`.js-ads-react-data-${ele}`).data("jobs"),
        });
        list.render();
      }
    });
  }
}
